import React from 'react';
import { Link } from 'react-router-dom';

function AboutMeSnippet({ yearsOfExperience }) {
  return (
    <section className="bg-bg-dark text-text-gray py-24">
      <div className="max-w-6xl mx-auto px-5">
        <h2 className="text-4xl text-text-white font-bold text-center mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
          About Me
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-12">
          <div className="flex-2 min-w-[300px] max-w-xl relative p-4">
            <div className="absolute top-0 left-2 text-9xl text-gray-400 opacity-30">“</div>
            <p className="mb-5 leading-relaxed">
              Welcome! I'm Rishabh Gupta. My journey into the world of programming started with a simple curiosity about how things work behind the scenes. Today, with over <strong>{yearsOfExperience} years of professional experience</strong> as a <strong>Senior Software Engineer</strong>, that curiosity has evolved into a dedicated passion for <strong>building the digital backbone of complex, modern applications</strong>.
            </p>
            <p className="mb-5 leading-relaxed">
              I spent my early engineering years perfecting application logic and automation, which naturally drew me toward <strong>large-scale enterprise systems</strong>. Today, I specialize in <strong>designing and engineering high-performance distributed architectures</strong>. I thrive on the challenge of making massive, invisible systems talk to each other seamlessly, ensuring they are <strong>scalable, efficient, and resilient</strong> under pressure.
            </p>
            <p className="mb-5 leading-relaxed">
              For me, software engineering isn't just about writing code—it's about <strong>crafting reliable solutions to real-world infrastructure challenges</strong>. This website is a small window into my engineering world. Feel free to explore my journey, and reach out if you'd like to connect or collaborate!
            </p>
            <div className="absolute bottom-4 right-28 text-9xl text-gray-400 opacity-30">”</div>
            <Link to="/about" className="text-accent-red border-2 border-accent-red rounded-full px-6 py-3 font-bold transition-all duration-300 hover:bg-accent-red hover:text-text-white no-underline inline-block mt-4">
              Read More
            </Link>
          </div>
          <div className="flex-1 min-w-[250px] text-center">
            <img src="/images/rishabh-gupta.jpg" alt="Rishabh Gupta" className="max-w-full h-auto rounded-lg shadow-xl border border-border-subtle mx-auto" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMeSnippet;